export type AudioRoute = 'speaker' | 'earpiece' | 'bluetooth';

function bridge(): any {
  return (window as any).EchoAndroid ?? null;
}

export function isAndroidNative(): boolean {
  return !!bridge();
}

export function getAvailableRoutes(): AudioRoute[] {
  try {
    const raw = bridge()?.getAudioRoutes?.();
    if (!raw) return [];
    return JSON.parse(raw) as AudioRoute[];
  } catch {
    return [];
  }
}

export function setAudioRoute(route: AudioRoute): void {
  try { bridge()?.setAudioRoute?.(route); } catch { /* noop */ }
}

export function nextRoute(current: AudioRoute, available: AudioRoute[]): AudioRoute {
  const idx = available.indexOf(current);
  return available[(idx + 1) % available.length] ?? current;
}

export const ROUTE_LABEL: Record<AudioRoute, string> = {
  speaker: 'Speaker',
  earpiece: 'Earpiece',
  bluetooth: 'Bluetooth',
};
